// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"99dcf01f","732":"010d0b1d","977":"aab437d2"}[chunkId] + ".chunk.js";
};